import React from "react";
import TuneRounded from "@mui/icons-material/TuneRounded";
import QueryStatsRounded from "@mui/icons-material/QueryStatsRounded";
import RocketLaunchRounded from "@mui/icons-material/RocketLaunchRounded";

import useInView from "hooks/useInView";
import "./howItWorks.scss";

const STEPS = [
  {
    title: "Set your criteria",
    description:
      "Pick a location, property type, and budget. NextFlip runs the scan.",
    Icon: TuneRounded,
  },
  {
    title: "Review scored deals",
    description:
      "Every match gets a Deal Score built from MLS, county, permit, and lender data — sources that used to require multiple paid subscriptions to access.",
    Icon: QueryStatsRounded,
  },
  {
    title: "Move fast and close",
    description:
      "Compare financing options, check contractor track records, and make an offer backed by data — not guesswork.",
    Icon: RocketLaunchRounded,
  },
];

const Step = ({ title, description, Icon }) => {
  const [ref, inView] = useInView();

  return (
    <div ref={ref} className={`step ${inView ? "visible" : ""}`}>
      <div className="step-marker">
        <span className="step-dot" />
      </div>
      <div className="step-body">
        <div className="step-icon">
          <Icon />
        </div>
        <h3 className="step-title">{title}</h3>
        <p className="step-description">{description}</p>
      </div>
    </div>
  );
};

const HowItWorks = () => (
  <section id="how-it-works" className="how-it-works">
    <div className="how-it-works-inner">
      <h2 className="how-it-works-heading">How it works</h2>
      <div className="steps">
        {STEPS.map((step, i) => (
          <Step key={step.title} {...step} />
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
